export default __webpack_public_path__ + "static/media/user.600cee7e.svg";